<template>
    <div class="cart-widget">
        <button @mouseover="showcart" @click="showcart" id="cart-widget-button" class="cart-widget-button">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
            <g>
                <g>
                    <path d="M214.685,402.828c-24.829,0-45.029,20.2-45.029,45.029c0,24.829,20.2,45.029,45.029,45.029s45.029-20.2,45.029-45.029
                        C259.713,423.028,239.513,402.828,214.685,402.828z M214.685,467.742c-10.966,0-19.887-8.922-19.887-19.887
                        c0-10.966,8.922-19.887,19.887-19.887s19.887,8.922,19.887,19.887C234.572,458.822,225.65,467.742,214.685,467.742z"/>
                </g>
            </g>
            <g>
                <g>
                    <path d="M372.63,402.828c-24.829,0-45.029,20.2-45.029,45.029c0,24.829,20.2,45.029,45.029,45.029s45.029-20.2,45.029-45.029
                        C417.658,423.028,397.458,402.828,372.63,402.828z M372.63,467.742c-10.966,0-19.887-8.922-19.887-19.887
                        c0-10.966,8.922-19.887,19.887-19.887c10.966,0,19.887,8.922,19.887,19.887C392.517,458.822,383.595,467.742,372.63,467.742z"/>
                </g>
            </g>
            <g>
                <g>
                    <path d="M383.716,165.755H203.567c-6.943,0-12.571,5.628-12.571,12.571c0,6.943,5.629,12.571,12.571,12.571h180.149
                        c6.943,0,12.571-5.628,12.571-12.571C396.287,171.382,390.659,165.755,383.716,165.755z"/>
                </g>
            </g>
            <g>
                <g>
                    <path d="M373.911,231.035H213.373c-6.943,0-12.571,5.628-12.571,12.571s5.628,12.571,12.571,12.571h160.537
                        c6.943,0,12.571-5.628,12.571-12.571C386.481,236.664,380.853,231.035,373.911,231.035z"/>
                </g>
            </g>
            <g>
                <g>
                    <path d="M506.341,109.744c-4.794-5.884-11.898-9.258-19.489-9.258H95.278L87.37,62.097c-1.651-8.008-7.113-14.732-14.614-17.989
                        l-55.177-23.95c-6.37-2.767-13.773,0.156-16.536,6.524c-2.766,6.37,0.157,13.774,6.524,16.537L62.745,67.17l60.826,295.261
                        c2.396,11.628,12.752,20.068,24.625,20.068h301.166c6.943,0,12.571-5.628,12.571-12.571c0-6.943-5.628-12.571-12.571-12.571
                        H148.197l-7.399-35.916H451.69c11.872,0,22.229-8.44,24.624-20.068l35.163-170.675
                        C513.008,123.266,511.136,115.627,506.341,109.744z M451.69,296.301H135.619l-35.161-170.674l386.393,0.001L451.69,296.301z"/>
                </g>
            </g>
            </svg>
            {{ (cartSum / 100).toFixed(2) }}р.
        </button>
        <div id="cart-widget-window" @mouseleave="hovered = false" v-if="hovered" class="cart-widget-window">
            <h2>Корзина</h2>
            <ul>
                <li v-for="item in cart" :key="item.code">
                    <span>{{ item.name }}</span>
                    <MenuItemSpin :MenuItem="item" :Summed="true"/>
                    <button class="deny" @click="delItem(item)">X</button>
                </li>
                <li>
                    <span>Итого</span>
                    <span> {{ (cartSum / 100).toFixed(2) }}р. </span>
                </li>
            </ul>
            <div class="cart-widget-actions">
                <button class="deny" @click="delCart">Очистить корзину</button>
                <button v-if="allowOrder" class="apply" @click="$emit('order')"> Оформить заказ </button>
                <button v-else class="deny">Минимальная сумма заказа: {{shop.minimalsum}}р. </button>
            </div>
            
        </div>
    </div>
</template>

<script>
import MenuItemSpin from './MenuItemSpin'

export default {
    props:['cart', 'shop'],
    data(){
        return{
            hovered: false,
            img:'./img/shopping-cart.svg'

        }
    },
    computed:{
        cartSum:function () {
            let amuont = 0
            for (let item of this.cart) {
                amuont += item.sum
            }
            return amuont
        },
        allowOrder(){
            if ((this.shop.minimalsum > 0) && (this.cartSum < this.shop.minimalsum*100)){
                return false
            } else return true
        }
    },
    mounted(){
        if (window.innerWidth < 500) {
            window.addEventListener('scroll', this.scrollHandler)
        }
    },
    destroyed(){
        window.removeEventListener('scroll', this.scrollHandler)
    },
    methods:{
        delItem: function(item){
            item.qty = 0
            item.sum = 0
        },
        delCart: function(){
            for (let item of this.cart){
                this.delItem(item)
            }
        },
        showcart: function (){
            this.hovered = this.cartSum > 0
        },
        scrollHandler(){
            if (this.hovered) this.hovered = false
        }
    },
    watch:{
        cartSum: function (val) {
            this.hovered = this.hovered && (val > 0)
        }
    },
    components:{
        MenuItemSpin
    }
}
</script>